export default "__VITE_ASSET__CyGee_e1__"